import { getHaklaiPreCalcInlineErrors } from "../preCalc/logic/haklaiPreCalcValidation";
import { getHaklaiPrisaMaxYears, getHaklaiPrisaMinYears, MAX_PRISA_YEARS } from "./haklaiPrisaHelpers";
import { HAKLAI_PRISA_MESSAGES } from "./haklaiPrisaTexts";

const lockedPrisaState = (reason, blocksLaterSections) => ({
  unlocked: false,
  blocksLaterSections,
  reason,
  blockingSection: "preCalc"
});

// Incomplete earlier fields block the rest of the form. A year span that
// makes spreading itself unavailable does not: the spreading section stays
// closed, and the offset / expropriation questions stay editable.
export const resolveHaklaiPrisaSectionState = ({
  hasPreCalcErrors = false,
  maxYears = MAX_PRISA_YEARS,
  minYears = MAX_PRISA_YEARS
} = {}) => {
  if (hasPreCalcErrors) {
    return lockedPrisaState(HAKLAI_PRISA_MESSAGES.preCalcRequired, true);
  }

  if (maxYears < 1) {
    return lockedPrisaState(HAKLAI_PRISA_MESSAGES.sameSalePurchaseYearUnavailable, false);
  }

  if (minYears === 0) {
    return lockedPrisaState(HAKLAI_PRISA_MESSAGES.partialPurchaseInSaleYearUnavailable, false);
  }

  return {
    unlocked: true,
    blocksLaterSections: false,
    reason: "",
    blockingSection: ""
  };
};

export const getHaklaiPrisaSectionState = (preCalc = {}) => {
  const preCalcErrors = getHaklaiPreCalcInlineErrors(preCalc);
  return resolveHaklaiPrisaSectionState({
    hasPreCalcErrors: Object.keys(preCalcErrors).length > 0,
    maxYears: getHaklaiPrisaMaxYears(preCalc),
    minYears: getHaklaiPrisaMinYears(preCalc)
  });
};
